export default __webpack_public_path__ + "static/media/menu-icon.3dff3133.png";